import { appConfigKey } from "commonAssets/js/constants";
import { safeTag } from "./safeTag.js";

export async function uploadFile(claim, s3env, upload, index, retryCount) {
    console.log(`uploadFile init...`);

    retryCount++;

    const params = {
        domain: claim.data.domain,
        filename: upload.file.name,
        type: upload.file.type,
        extension: upload.file.name.split(".").pop(),
        description: upload.description,
        timestamp: Date.now(),
        index: index,
    };

    // Add Your Key Here!!!
    if (axios.defaults.headers.common["x-api-key"] == undefined) {
        axios.defaults.headers.common = {
            "Content-Type": "application/json",
            "x-api-key": appConfigKey,
        };
    }

    const res = await axios.get(s3env + "/s3Uploader", { params });

    const tags = {
        domain: claim.data.domain,
        name: safeTag(upload.file.name),
        description: safeTag(upload.description),
    };

    // Build tag query string
    const tag_query = Object.keys(tags)
        .map(function (k) {
            return encodeURIComponent(k) + "=" + encodeURIComponent(tags[k]);
        })
        .join("&");
    // S3 signed URL headers
    const options = {
        headers: {
            "Content-Type": upload.file.type,
            "x-amz-tagging": tag_query,
        },
    };
    // Put file to S3
    let s3post;
    let errorMessage = "";
    try {
        s3post = await axios.put(res.data.uploadURL, upload.file, options);
    } catch (error) {
        errorMessage = error;
    }

    if (s3post.status == 200) {
        console.log("s3post status 200...");
        //if succeeded, write to claim_files
        const file = {
            filename: res.data.fileName,
            description: upload.description,
            filetype: upload.file.type,
            error: undefined,
            name: upload.file.name,
            failed: false,
            hash: upload.hash,
            doc_id: upload.doc_id || "submit-claim",
        };

        claim.data.files.push(file);
    } else {
        //if failed recursivelly call 5x, then abort
        //retry 3x
        if (retryCount <= 3) {
            console.log("s3post failure, trying again...");
            wait(1000);
            uploadFile(upload, index, retryCount);
        } else {
            if (errorMessage == "") errorMessage = s3post;
            const fileData = {
                filename: filename,
                description: upload.description,
                filetype: upload.file.type,
                name: upload.file.name,
                // error: JSON.stringify(s3post),
                error: JSON.stringify(errorMessage),
                failed: true,
                hash: upload.hash,
                doc_id: upload.doc_id || "submit-claim",
            };
            claim.data.files.push(fileData);
        }
    }
}
